import { useAtom } from 'jotai';
import { useMemo } from 'react';

import type { PERMISSIONS_LOGIC } from '@/constants/common';
import { orgProductsAtom } from '@/pages/Organizations';
import { checkProductSubTypes, checkProducts } from '@/services/permissions';

export const useProductsCheck = (
  requiredProducts?: string[],
  logic?: PERMISSIONS_LOGIC
) => {
  const [orgProducts] = useAtom(orgProductsAtom);

  const hasRequiredProducts = useMemo(() => {
    return checkProducts(orgProducts, requiredProducts, logic);
  }, [orgProducts, requiredProducts, logic]);

  return hasRequiredProducts; // Only show item if org has required products
};

export const useProductSubTypesCheck = (
  requiredProductSubTypes?: string[],
  logic?: PERMISSIONS_LOGIC
) => {
  const [orgProducts] = useAtom(orgProductsAtom);

  const hasRequiredProductSubTypes = useMemo(() => {
    return checkProductSubTypes(orgProducts, requiredProductSubTypes, logic);
  }, [orgProducts, requiredProductSubTypes, logic]);

  return hasRequiredProductSubTypes; // Only show item if org has required product sub types
};

export default useProductsCheck;
